/**
 * Pillola di risposta rapida. Lo stato "scelta" non e mai solo colore (DESIGN-TOKENS §3.1):
 * compare un segno di spunta e un bordo ink, e lo screen reader legge aria-pressed.
 */
export type ChoiceChipProps = {
  label: string
  selected?: boolean
  onSelect?: (label: string) => void
  disabled?: boolean
}

export function ChoiceChip({ label, selected = false, onSelect, disabled }: ChoiceChipProps) {
  return (
    <button
      type="button"
      aria-pressed={selected}
      disabled={disabled}
      onClick={() => onSelect?.(label)}
      className={[
        'motion-colors inline-flex min-h-touch items-center gap-2 rounded-full border-2 px-4 py-1.5 text-left text-meta text-ink',
        selected ? 'border-ink bg-chip-selected' : 'border-transparent bg-chip',
        disabled ? 'cursor-not-allowed opacity-60' : '',
      ].join(' ')}
    >
      {selected && <CheckIcon />}
      <span>{label}</span>
    </button>
  )
}

function CheckIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      className="h-[1em] w-[1em] shrink-0"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12.5l4.5 4.5L19 7.5" />
    </svg>
  )
}
